module.exports = __webpack_public_path__ + "static/media/CC20-AP040-12.315a96ef.png";